import React from 'react'
import { MwSpinnerIcon } from './MwLoadingOverlay'

const MwSpinnerButton = ({withLabel=true, label , isFullCenter = false}) => {
    return (
        <button type="button" className={`flex items-center gap-1 justify-center text-xs  text-indigo-500  p-2 ${ isFullCenter && 'w-full h-full'}`}   disabled >
            <MwSpinnerIcon size={20} />
            { withLabel && <span> {label ? label : 'جاري التحميل...'} </span> }
        </button>
    )
}

export default MwSpinnerButton